import { processAppMetaData } from 'bridge';
import {
  LOCAL_STORAGE,
  LOCAL_STORAGE_FALSE,
  MAC_APP_DATA_LOCATION,
  PLATFORMS
} from 'constants/general';
import { ToDoTaskAppMetaDataType } from 'interfaces';
import {
  resetToDoPlayer,
  updateIncomingTasks,
  updateBrainDump,
  updatePlayerIntention
} from 'store/reducer/to-do/slice';
import { getAppDispatch } from 'store/store-access';
import { parseIncomingTasks } from 'bridge/parse-incoming-tasks.util';
import { sendDataToPlatform } from 'bridge/sync-data.bridge';
import { getLocalStorage, updateLocalStorage } from 'utils/helpers/storage';
import { sanitizeInput } from 'utils/todo.util';

export const exposeStopToDoPlayer = () => {
  window.stopToDoPlayer = () => getAppDispatch()?.(resetToDoPlayer());
};

export const exposeLoadIntentionForToDoPlayer = () => {
  window.loadIntentionForToDoPlayer = (data: string) => {
    const sanitizedIntention = sanitizeInput(data?.toString());
    getAppDispatch()?.(updatePlayerIntention(sanitizedIntention));
  };
};

export const exposeUpdateBrainDumpFromDesktopApp = () => {
  window.updateBrainDumpFromDesktopApp = (data: string) => {
    updateLocalStorage(LOCAL_STORAGE.IS_BRAIN_DUMP_READY, LOCAL_STORAGE_FALSE);
    const brainDump = decodeURIComponent(data ?? '');
    const sanitizedBrainDump = sanitizeInput(brainDump);
    getAppDispatch()?.(updateBrainDump(sanitizedBrainDump));
  };
};

export const exposeGetToDosFromPlayer = (platform?: string) => {
  window.getToDosFromPlayer = () => {
    const raw = getLocalStorage(LOCAL_STORAGE.TO_DO_PLAYER_TASKS);
    const deserializedTasks = parseIncomingTasks({ tasks: raw });
    const isMacPlatform = platform === PLATFORMS.MAC;

    if (platform) {
      sendDataToPlatform(
        platform,
        isMacPlatform ? deserializedTasks : { tasks: deserializedTasks },
        MAC_APP_DATA_LOCATION.SEND_NEW_TASK_FROM_TO_DO_PLAYER
      );
    }

    return deserializedTasks;
  };
};

export const exposeLoadAccessTokenForToDo = () =>
  (window.loadAccessTokenForToDo = (data: ToDoTaskAppMetaDataType) => {
    getAppDispatch()?.(updateIncomingTasks(parseIncomingTasks(data)));
    processAppMetaData(data);
  });
